import { Flex } from '@/ui/Flex/Flex';
import { Editor } from '@monaco-editor/react';
import React from 'react';
import { T } from '@/ui/Text/Text';
import { IconCloseSidebar, IconExpandSidebar } from '@/icons';
import { Button } from '@/ui/Button/Button';
import { Tooltip } from '@/ui/Tooltip/Tooltip';
import {
  StyledContentPayloadEditorWrapper,
  StyledContentPayloadSidebar,
} from './styles';

type ContentPayloadSidebarProps = {
  contentPayload?: object;
  isContentPayloadSidebarOpen: boolean;
  setIsContentPayloadSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
};
function ContentPayloadSidebar({
  contentPayload,
  isContentPayloadSidebarOpen,
  setIsContentPayloadSidebarOpen,
}: ContentPayloadSidebarProps) {
  return (
    <StyledContentPayloadSidebar isExpanded={isContentPayloadSidebarOpen}>
      <Flex justify="space-between" align="center">
        {isContentPayloadSidebarOpen && <T h4>Content Payload</T>}
        <Tooltip
          title={
            !isContentPayloadSidebarOpen
              ? 'Show Content Payload'
              : 'Hide Sidebar'
          }
          pos="right"
        >
          <Button
            testId="expand-collapse-button"
            mode="transparent"
            size="minimum"
            onClick={() =>
              setIsContentPayloadSidebarOpen(!isContentPayloadSidebarOpen)
            }
          >
            {isContentPayloadSidebarOpen ? (
              <IconCloseSidebar />
            ) : (
              <IconExpandSidebar />
            )}
          </Button>
        </Tooltip>
      </Flex>
      {isContentPayloadSidebarOpen && (
        <StyledContentPayloadEditorWrapper>
          <Editor
            defaultLanguage="json"
            defaultValue={JSON.stringify(contentPayload || '', null, 4)}
            options={{
              readOnly: true,
              minimap: { enabled: false },
              folding: false,
              lineDecorationsWidth: 8,
              lineNumbersMinChars: 3,
              fontSize: 14,
            }}
            theme="vs-dark"
          />
        </StyledContentPayloadEditorWrapper>
      )}
    </StyledContentPayloadSidebar>
  );
}

export default ContentPayloadSidebar;
